/* Metaobject page interactions.

   Two things, both progressive enhancement:
     - the ingredient entry's contents rail highlights the section in view
     - the ingredient index filters by cuisine and search

   With scripting off the contents rail is still a working list of anchors,
   and the index still lists every entry with every link intact. Only the
   narrowing is lost.
*/

(function () {
  'use strict';

  /* Contents rail. The active section takes a rule via .is-active —
     no fill, no pill, no dot. */
  function setupContents() {
    const nav = document.querySelector('[data-dopa-contents]');
    if (!nav || !('IntersectionObserver' in window)) return;

    const links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    const sections = links
      .map(function (link) { return document.getElementById(link.getAttribute('href').slice(1)); })
      .filter(Boolean);
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) {
            link.classList.toggle(
              'is-active',
              link.getAttribute('href') === '#' + entry.target.id
            );
          });
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    sections.forEach(function (section) { observer.observe(section); });
  }

  /* Ingredient index: search plus cuisine filter, both client-side. */
  function setupIndex() {
    const root = document.querySelector('[data-dopa-index]');
    if (!root) return;

    const search = root.querySelector('[data-dopa-index-search]');
    const buttons = Array.prototype.slice.call(root.querySelectorAll('[data-dopa-index-cuisine]'));
    const typeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dopa-index-type]'));
    const items = Array.prototype.slice.call(root.querySelectorAll('[data-dopa-index-item]'));
    const groups = Array.prototype.slice.call(root.querySelectorAll('[data-dopa-index-group]'));
    const count = root.querySelector('[data-dopa-index-count]');
    const empty = root.querySelector('[data-dopa-index-empty]');

    let term = '';
    let cuisine = '';
    let type = '';

    function apply() {
      let shown = 0;

      items.forEach(function (item) {
        const name = item.getAttribute('data-name') || '';
        const alt = item.getAttribute('data-alt') || '';
        const cuisines = item.getAttribute('data-cuisines') || '';

        const matchesTerm = !term || name.indexOf(term) !== -1 || alt.indexOf(term) !== -1;
        const matchesCuisine = !cuisine || cuisines.split(/\s+/).indexOf(cuisine) !== -1;
        // Type composes with cuisine and search rather than replacing them.
        const matchesType = !type || (item.getAttribute('data-type') || '') === type;
        const visible = matchesTerm && matchesCuisine && matchesType;

        item.hidden = !visible;
        if (visible) shown += 1;
      });

      // A letter group with nothing left in it collapses itself, and one that
      // keeps entries says how many it is now showing, not how many it holds.
      groups.forEach(function (group) {
        const visible = group.querySelectorAll('[data-dopa-index-item]:not([hidden])').length;
        group.hidden = visible === 0;
        const label = group.querySelector('[data-dopa-index-group-count]');
        if (label) {
          const pattern = label.getAttribute(visible === 1 ? 'data-one' : 'data-other') || '';
          if (pattern) label.textContent = pattern.replace('#', String(visible));
        }
      });

      if (count) {
        const label = count.textContent.replace(/^\s*\d+\s*/, '').trim();
        count.innerHTML = '<span data-tabular>' + shown + '</span> ' + label;
      }
      if (empty) empty.hidden = shown !== 0;
    }

    if (search) {
      search.addEventListener('input', function () {
        term = search.value.trim().toLowerCase();
        apply();
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        cuisine = button.getAttribute('data-dopa-index-cuisine') || '';
        buttons.forEach(function (b) {
          b.classList.toggle('dopa-chip--active', b === button);
        });
        apply();
      });
    });

    // The type row draws no "All" chip, so pressing the active type clears it.
    typeButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', function () {
        const value = button.getAttribute('data-dopa-index-type') || '';
        type = type === value ? '' : value;
        typeButtons.forEach(function (b) {
          const on = type !== '' && b.getAttribute('data-dopa-index-type') === type;
          b.classList.toggle('dopa-chip--active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    // Deep link: /pages/ingredients?cuisine=thai, as the cuisine page links.
    const params = new URLSearchParams(window.location.search);
    const preset = params.get('cuisine');
    if (preset) {
      const match = buttons.filter(function (b) {
        return b.getAttribute('data-dopa-index-cuisine') === preset;
      })[0];
      if (match) match.click();
    }
  }

  function boot() {
    setupContents();
    setupIndex();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
